export const cities = [{
    loc: [107.7539, 30.1904],
    fullName: "重庆市"
}, {
    loc: [116.4551, 40.2539],
    fullName: "北京市"
}, {
    loc: [117.4219, 39.4189],
    fullName: "天津市"
}, {
    loc: [121.4648, 31.2891],
    fullName: "上海市"
}, {
    loc: [121.5200889821, 25.0307355818],
    fullName: "台北市"
}, {
    loc: [123.4806113958, 25.7836010006],
    fullName: "钓鱼岛"
}, {
    loc: [112.3537503, 16.8294262],
    fullName: "三沙市"
}, {
    loc: [120.6798749119, 24.1431627616],
    fullName: "台中市"
}, {
    loc: [120.3068344788, 22.6305697952],
    fullName: "高雄市"
}, {
    loc: [120.1878282606, 22.9986095417],
    fullName: "台南市"
}, {
    loc: [114.2578, 22.3242],
    fullName: "香港"
}, {
    loc: [113.5547, 22.1484],
    fullName: "澳门"
}, {
    loc: [88.1653, 39.6002],
    fullName: "巴音郭楞蒙古自治州"
}, {
    loc: [81.167, 36.9855],
    fullName: "和田地区"
}, {
    loc: [93.7793, 42.9236],
    fullName: "哈密地区"
}, {
    loc: [82.9797, 41.0229],
    fullName: "阿克苏地区"
}, {
    loc: [88.2971, 47.0929],
    fullName: "阿勒泰地区"
}, {
    loc: [77.168, 37.8534],
    fullName: "喀什地区"
}, {
    loc: [86.6272, 45.8514],
    fullName: "塔城地区"
}, {
    loc: [89.6814, 44.4507],
    fullName: "昌吉回族自治州"
}, {
    loc: [74.6301, 39.5233],
    fullName: "克孜勒苏柯尔克孜自治州"
}, {
    loc: [89.6375, 42.4127],
    fullName: "吐鲁番地区"
}, {
    loc: [82.5513, 43.5498],
    fullName: "伊犁哈萨克自治州"
}, {
    loc: [81.8481, 44.6979],
    fullName: "博尔塔拉蒙古自治州"
}, {
    loc: [87.9236, 43.5883],
    fullName: "乌鲁木齐市"
}, {
    loc: [85.2869, 45.5054],
    fullName: "克拉玛依市"
}, {
    loc: [81.2769, 40.6549],
    fullName: "阿拉尔市"
}, {
    loc: [79.1345, 39.8749],
    fullName: "图木舒克市"
}, {
    loc: [87.5391, 44.3024],
    fullName: "五家渠市"
}, {
    loc: [86.0229, 44.2914],
    fullName: "石河子市"
}, {
    loc: [88.1982, 33.3215],
    fullName: "那曲地区"
}, {
    loc: [82.3645, 32.7667],
    fullName: "阿里地区"
}, {
    loc: [86.2427, 29.5093],
    fullName: "日喀则地区"
}, {
    loc: [95.4602, 29.1138],
    fullName: "林芝地区"
}, {
    loc: [97.0203, 30.7068],
    fullName: "昌都地区"
}, {
    loc: [92.2083, 28.3392],
    fullName: "山南地区"
}, {
    loc: [91.1865, 30.1465],
    fullName: "拉萨市"
}, {
    loc: [120.8057, 50.2185],
    fullName: "呼伦贝尔市"
}, {
    loc: [102.019, 40.1001],
    fullName: "阿拉善盟"
}, {
    loc: [115.6421, 44.176],
    fullName: "锡林郭勒盟"
}, {
    loc: [108.9734, 39.2487],
    fullName: "鄂尔多斯市"
}, {
    loc: [118.6743, 43.2642],
    fullName: "赤峰市"
}, {
    loc: [107.5562, 41.3196],
    fullName: "巴彦淖尔市"
}, {
    loc: [121.4758, 43.9673],
    fullName: "通辽市"
}, {
    loc: [112.5769, 41.77],
    fullName: "乌兰察布市"
}, {
    loc: [121.3879, 46.1426],
    fullName: "兴安盟"
}, {
    loc: [110.3467, 41.4899],
    fullName: "包头市"
}, {
    loc: [111.4124, 40.4901],
    fullName: "呼和浩特市"
}, {
    loc: [106.886, 39.4739],
    fullName: "乌海市"
}, {
    loc: [94.9768, 37.1118],
    fullName: "海西蒙古族藏族自治州"
}, {
    loc: [93.5925, 33.9368],
    fullName: "玉树藏族自治州"
}, {
    loc: [99.3823, 34.0466],
    fullName: "果洛藏族自治州"
}, {
    loc: [100.3711, 35.9418],
    fullName: "海南藏族自治州"
}, {
    loc: [100.3711, 37.9138],
    fullName: "海北藏族自治州"
}, {
    loc: [101.5686, 35.1178],
    fullName: "黄南藏族自治州"
}, {
    loc: [102.3706, 36.2988],
    fullName: "海东地区"
}, {
    loc: [101.4038, 36.8207],
    fullName: "西宁市"
}, {
    loc: [99.9207, 31.0803],
    fullName: "甘孜藏族自治州"
}, {
    loc: [102.4805, 32.4536],
    fullName: "阿坝藏族羌族自治州"
}, {
    loc: [101.9641, 27.6746],
    fullName: "凉山彝族自治州"
}, {
    loc: [104.7327, 31.8713],
    fullName: "绵阳市"
}, {
    loc: [107.6111, 31.333],
    fullName: "达州市"
}, {
    loc: [105.6885, 32.2284],
    fullName: "广元市"
}, {
    loc: [102.6672, 29.8938],
    fullName: "雅安市"
}, {
    loc: [104.6558, 28.548],
    fullName: "宜宾市"
}, {
    loc: [103.5791, 29.1742],
    fullName: "乐山市"
}, {
    loc: [106.2048, 31.1517],
    fullName: "南充市"
}, {
    loc: [107.0618, 31.9977],
    fullName: "巴中市"
}, {
    loc: [105.4578, 28.493],
    fullName: "泸州市"
}, {
    loc: [103.9526, 30.7617],
    fullName: "成都市"
}, {
    loc: [104.9744, 30.1575],
    fullName: "资阳市"
}, {
    loc: [101.6895, 26.7133],
    fullName: "攀枝花市"
}, {
    loc: [103.8098, 30.0146],
    fullName: "眉山市"
}, {
    loc: [106.6333, 30.4376],
    fullName: "广安市"
}, {
    loc: [104.48, 31.1133],
    fullName: "德阳市"
}, {
    loc: [104.8535, 29.6136],
    fullName: "内江市"
}, {
    loc: [105.5347, 30.6683],
    fullName: "遂宁市"
}, {
    loc: [104.6667, 29.2786],
    fullName: "自贡市"
}, {
    loc: [127.1448, 49.2957],
    fullName: "黑河市"
}, {
    loc: [124.1016, 52.2345],
    fullName: "大兴安岭地区"
}, {
    loc: [127.9688, 45.368],
    fullName: "哈尔滨市"
}, {
    loc: [124.541, 47.5818],
    fullName: "齐齐哈尔市"
}, {
    loc: [129.7815, 44.7089],
    fullName: "牡丹江市"
}, {
    loc: [126.7163, 46.8018],
    fullName: "绥化市"
}, {
    loc: [129.1992, 47.9608],
    fullName: "伊春市"
}, {
    loc: [133.0005, 47.5763],
    fullName: "佳木斯市"
}, {
    loc: [132.7917, 45.7361],
    fullName: "鸡西市"
}, {
    loc: [133.5938, 46.7523],
    fullName: "双鸭山市"
}, {
    loc: [124.7717, 46.4282],
    fullName: "大庆市"
}, {
    loc: [130.4407, 47.7081],
    fullName: "鹤岗市"
}, {
    loc: [131.2756, 45.9558],
    fullName: "七台河市"
}, {
    loc: [96.2622, 40.4517],
    fullName: "酒泉市"
}, {
    loc: [99.7998, 38.7433],
    fullName: "张掖市"
}, {
    loc: [102.9199, 34.6893],
    fullName: "甘南藏族自治州"
}, {
    loc: [103.0188, 38.1061],
    fullName: "武威市"
}, {
    loc: [105.304, 33.5632],
    fullName: "陇南市"
}, {
    loc: [107.5342, 36.2],
    fullName: "庆阳市"
}, {
    loc: [104.8645, 36.5076],
    fullName: "白银市"
}, {
    loc: [104.5569, 35.0848],
    fullName: "定西市"
}, {
    loc: [105.6445, 34.6289],
    fullName: "天水市"
}, {
    loc: [103.5901, 36.3043],
    fullName: "兰州市"
}, {
    loc: [107.0728, 35.321],
    fullName: "平凉市"
}, {
    loc: [103.2715, 35.5737],
    fullName: "临夏回族自治州"
}, {
    loc: [102.074, 38.5126],
    fullName: "金昌市"
}, {
    loc: [98.1738, 39.8035],
    fullName: "嘉峪关市"
}, {
    loc: [100.7446, 23.4229],
    fullName: "普洱市"
}, {
    loc: [103.0408, 23.6041],
    fullName: "红河哈尼族彝族自治州"
}, {
    loc: [104.8865, 23.5712],
    fullName: "文山壮族苗族自治州"
}, {
    loc: [103.9417, 25.7025],
    fullName: "曲靖市"
}, {
    loc: [101.6016, 25.3619],
    fullName: "楚雄彝族自治州"
}, {
    loc: [99.9536, 25.6805],
    fullName: "大理白族自治州"
}, {
    loc: [99.613, 24.0546],
    fullName: "临沧市"
}, {
    loc: [99.4592, 27.9327],
    fullName: "迪庆藏族自治州"
}, {
    loc: [104.0955, 27.6031],
    fullName: "昭通市"
}, {
    loc: [102.9199, 25.4663],
    fullName: "昆明市"
}, {
    loc: [100.448, 26.955],
    fullName: "丽江市"
}, {
    loc: [100.8984, 21.8628],
    fullName: "西双版纳傣族自治州"
}, {
    loc: [99.0637, 24.9884],
    fullName: "保山市"
}, {
    loc: [101.9312, 23.8898],
    fullName: "玉溪市"
}, {
    loc: [99.1516, 26.5594],
    fullName: "怒江傈僳族自治州"
}, {
    loc: [98.1299, 24.5874],
    fullName: "德宏傣族景颇族自治州"
}, {
    loc: [106.6003, 23.9227],
    fullName: "百色市"
}, {
    loc: [107.8638, 24.5819],
    fullName: "河池市"
}, {
    loc: [110.5554, 25.318],
    fullName: "桂林市"
}, {
    loc: [108.479, 23.1152],
    fullName: "南宁市"
}, {
    loc: [109.3799, 24.9774],
    fullName: "柳州市"
}, {
    loc: [107.3364, 22.4725],
    fullName: "崇左市"
}, {
    loc: [109.7095, 23.8403],
    fullName: "来宾市"
}, {
    loc: [110.2148, 22.3792],
    fullName: "玉林市"
}, {
    loc: [110.9949, 23.5052],
    fullName: "梧州市"
}, {
    loc: [111.3135, 24.4006],
    fullName: "贺州市"
}, {
    loc: [109.0283, 22.0935],
    fullName: "钦州市"
}, {
    loc: [109.9402, 23.3459],
    fullName: "贵港市"
}, {
    loc: [108.0505, 21.9287],
    fullName: "防城港市"
}, {
    loc: [109.314, 21.6211],
    fullName: "北海市"
}, {
    loc: [109.9512, 27.4438],
    fullName: "怀化市"
}, {
    loc: [111.709, 25.752],
    fullName: "永州市"
}, {
    loc: [110.9619, 26.8121],
    fullName: "邵阳市"
}, {
    loc: [113.2361, 25.8673],
    fullName: "郴州市"
}, {
    loc: [111.4014, 29.2676],
    fullName: "常德市"
}, {
    loc: [109.7864, 28.6743],
    fullName: "湘西土家族苗族自治州"
}, {
    loc: [112.4121, 26.7902],
    fullName: "衡阳市"
}, {
    loc: [113.2361, 29.1357],
    fullName: "岳阳市"
}, {
    loc: [111.731, 28.3832],
    fullName: "益阳市"
}, {
    loc: [113.0823, 28.2568],
    fullName: "长沙市"
}, {
    loc: [113.5327, 27.0319],
    fullName: "株洲市"
}, {
    loc: [110.5115, 29.328],
    fullName: "张家界市"
}, {
    loc: [111.6431, 27.7185],
    fullName: "娄底市"
}, {
    loc: [112.5439, 27.7075],
    fullName: "湘潭市"
}, {
    loc: [109.8743, 38.205],
    fullName: "榆林市"
}, {
    loc: [109.1052, 36.4252],
    fullName: "延安市"
}, {
    loc: [106.886, 33.0139],
    fullName: "汉中市"
}, {
    loc: [109.1162, 32.7722],
    fullName: "安康市"
}, {
    loc: [109.8083, 33.761],
    fullName: "商洛市"
}, {
    loc: [107.1826, 34.3433],
    fullName: "宝鸡市"
}, {
    loc: [109.7864, 35.0299],
    fullName: "渭南市"
}, {
    loc: [108.4131, 34.8706],
    fullName: "咸阳市"
}, {
    loc: [109.1162, 34.2004],
    fullName: "西安市"
}, {
    loc: [109.0393, 35.1947],
    fullName: "铜川市"
}, {
    loc: [112.9175, 24.3292],
    fullName: "清远市"
}, {
    loc: [113.7964, 24.7028],
    fullName: "韶关市"
}, {
    loc: [110.3577, 20.9894],
    fullName: "湛江市"
}, {
    loc: [116.1255, 24.1534],
    fullName: "梅州市"
}, {
    loc: [114.917, 23.9722],
    fullName: "河源市"
}, {
    loc: [112.1265, 23.5822],
    fullName: "肇庆市"
}, {
    loc: [114.6204, 23.1647],
    fullName: "惠州市"
}, {
    loc: [111.0059, 22.0221],
    fullName: "茂名市"
}, {
    loc: [112.6318, 22.1484],
    fullName: "江门市"
}, {
    loc: [111.8298, 22.0715],
    fullName: "阳江市"
}, {
    loc: [111.7859, 22.8516],
    fullName: "云浮市"
}, {
    loc: [113.5107, 23.2196],
    fullName: "广州市"
}, {
    loc: [115.5762, 23.0438],
    fullName: "汕尾市"
}, {
    loc: [116.1255, 23.313],
    fullName: "揭阳市"
}, {
    loc: [113.7305, 22.1155],
    fullName: "珠海市"
}, {
    loc: [112.8955, 23.1097],
    fullName: "佛山市"
}, {
    loc: [116.7847, 23.8293],
    fullName: "潮州市"
}, {
    loc: [117.1692, 23.3405],
    fullName: "汕头市"
}, {
    loc: [114.5435, 22.5439],
    fullName: "深圳市"
}, {
    loc: [113.8953, 22.901],
    fullName: "东莞市"
}, {
    loc: [113.4229, 22.478],
    fullName: "中山市"
}, {
    loc: [129.397, 43.2587],
    fullName: "延边朝鲜族自治州"
}, {
    loc: [126.8372, 43.6047],
    fullName: "吉林市"
}, {
    loc: [123.0029, 45.2637],
    fullName: "白城市"
}, {
    loc: [124.0906, 44.7198],
    fullName: "松原市"
}, {
    loc: [125.8154, 44.2584],
    fullName: "长春市"
}, {
    loc: [127.2217, 42.0941],
    fullName: "白山市"
}, {
    loc: [125.9583, 41.8579],
    fullName: "通化市"
}, {
    loc: [124.541, 43.4894],
    fullName: "四平市"
}, {
    loc: [125.343, 42.7643],
    fullName: "辽源市"
}, {
    loc: [117.5757, 41.4075],
    fullName: "承德市"
}, {
    loc: [115.1477, 40.8527],
    fullName: "张家口市"
}, {
    loc: [115.0488, 39.0948],
    fullName: "保定市"
}, {
    loc: [118.4766, 39.6826],
    fullName: "唐山市"
}, {
    loc: [116.8286, 38.2104],
    fullName: "沧州市"
}, {
    loc: [114.4995, 38.1006],
    fullName: "石家庄市"
}, {
    loc: [114.8071, 37.2821],
    fullName: "邢台市"
}, {
    loc: [114.4775, 36.535],
    fullName: "邯郸市"
}, {
    loc: [119.2126, 40.0232],
    fullName: "秦皇岛市"
}, {
    loc: [115.8838, 37.7161],
    fullName: "衡水市"
}, {
    loc: [116.521, 39.0509],
    fullName: "廊坊市"
}, {
    loc: [109.5007, 30.2563],
    fullName: "恩施土家族苗族自治州"
}, {
    loc: [110.5115, 32.3877],
    fullName: "十堰市"
}, {
    loc: [111.1707, 30.7617],
    fullName: "宜昌市"
}, {
    loc: [111.9397, 31.9263],
    fullName: "襄樊市"
}, {
    loc: [115.2686, 30.6628],
    fullName: "黄冈市"
}, {
    loc: [113.291, 30.0092],
    fullName: "荆州市"
}, {
    loc: [112.6758, 30.9979],
    fullName: "荆门市"
}, {
    loc: [114.2578, 29.6631],
    fullName: "咸宁市"
}, {
    loc: [113.4338, 31.8768],
    fullName: "随州市"
}, {
    loc: [113.9502, 31.1188],
    fullName: "孝感市"
}, {
    loc: [114.3896, 30.6628],
    fullName: "武汉市"
}, {
    loc: [115.0159, 29.9213],
    fullName: "黄石市"
}, {
    loc: [110.4565, 31.5802],
    fullName: "神农架林区"
}, {
    loc: [113.0273, 30.6409],
    fullName: "天门市"
}, {
    loc: [113.3789, 30.3003],
    fullName: "仙桃市"
}, {
    loc: [112.7637, 30.3607],
    fullName: "潜江市"
}, {
    loc: [114.7302, 30.4102],
    fullName: "鄂州市"
}, {
    loc: [106.908, 28.1744],
    fullName: "遵义市"
}, {
    loc: [108.4241, 26.4166],
    fullName: "黔东南苗族侗族自治州"
}, {
    loc: [105.1611, 27.0648],
    fullName: "毕节地区"
}, {
    loc: [107.2485, 25.8398],
    fullName: "黔南布依族苗族自治州"
}, {
    loc: [108.6218, 28.0096],
    fullName: "铜仁地区"
}, {
    loc: [105.5347, 25.3949],
    fullName: "黔西南布依族苗族自治州"
}, {
    loc: [104.7546, 26.0925],
    fullName: "六盘水市"
}, {
    loc: [105.9082, 25.9882],
    fullName: "安顺市"
}, {
    loc: [106.6992, 26.7682],
    fullName: "贵阳市"
}, {
    loc: [120.7397, 37.5128],
    fullName: "烟台市"
}, {
    loc: [118.3118, 35.2936],
    fullName: "临沂市"
}, {
    loc: [119.0918, 36.524],
    fullName: "潍坊市"
}, {
    loc: [120.4651, 36.3373],
    fullName: "青岛市"
}, {
    loc: [115.6201, 35.2057],
    fullName: "菏泽市"
}, {
    loc: [116.8286, 35.3375],
    fullName: "济宁市"
}, {
    loc: [116.6858, 37.2107],
    fullName: "德州市"
}, {
    loc: [117.8174, 37.4963],
    fullName: "滨州市"
}, {
    loc: [115.9167, 36.4032],
    fullName: "聊城市"
}, {
    loc: [118.7073, 37.5513],
    fullName: "东营市"
}, {
    loc: [117.1582, 36.8701],
    fullName: "济南市"
}, {
    loc: [117.0264, 36.0516],
    fullName: "泰安市"
}, {
    loc: [121.9482, 37.1393],
    fullName: "威海市"
}, {
    loc: [119.2786, 35.5023],
    fullName: "日照市"
}, {
    loc: [118.0371, 36.6064],
    fullName: "淄博市"
}, {
    loc: [117.323, 34.8926],
    fullName: "枣庄市"
}, {
    loc: [117.6526, 36.2714],
    fullName: "莱芜市"
}, {
    loc: [115.2795, 25.8124],
    fullName: "赣州市"
}, {
    loc: [114.884, 26.9659],
    fullName: "吉安市"
}, {
    loc: [117.8613, 28.7292],
    fullName: "上饶市"
}, {
    loc: [115.4224, 29.3774],
    fullName: "九江市"
}, {
    loc: [116.4441, 27.4933],
    fullName: "抚州市"
}, {
    loc: [115.0159, 28.3228],
    fullName: "宜春市"
}, {
    loc: [116.0046, 28.6633],
    fullName: "南昌市"
}, {
    loc: [117.334, 29.3225],
    fullName: "景德镇市"
}, {
    loc: [113.9282, 27.4823],
    fullName: "萍乡市"
}, {
    loc: [117.0813, 28.2349],
    fullName: "鹰潭市"
}, {
    loc: [114.95, 27.8174],
    fullName: "新余市"
}, {
    loc: [112.4011, 33.0359],
    fullName: "南阳市"
}, {
    loc: [114.8291, 32.0197],
    fullName: "信阳市"
}, {
    loc: [112.0605, 34.3158],
    fullName: "洛阳市"
}, {
    loc: [114.1589, 32.9041],
    fullName: "驻马店市"
}, {
    loc: [114.873, 33.6951],
    fullName: "周口市"
}, {
    loc: [115.741, 34.2828],
    fullName: "商丘市"
}, {
    loc: [110.8301, 34.3158],
    fullName: "三门峡市"
}, {
    loc: [114.2029, 35.3595],
    fullName: "新乡市"
}, {
    loc: [112.9724, 33.739],
    fullName: "平顶山市"
}, {
    loc: [113.4668, 34.6234],
    fullName: "郑州市"
}, {
    loc: [114.5325, 36.0022],
    fullName: "安阳市"
}, {
    loc: [114.5764, 34.6124],
    fullName: "开封市"
}, {
    loc: [112.8406, 35.1508],
    fullName: "焦作市"
}, {
    loc: [113.6975, 34.0466],
    fullName: "许昌市"
}, {
    loc: [115.1917, 35.799],
    fullName: "濮阳市"
}, {
    loc: [113.8733, 33.6951],
    fullName: "漯河市"
}, {
    loc: [114.3787, 35.744],
    fullName: "鹤壁市"
}, {
    loc: [122.2229, 39.4409],
    fullName: "大连市"
}, {
    loc: [120.0696, 41.4899],
    fullName: "朝阳市"
}, {
    loc: [124.541, 40.4242],
    fullName: "丹东市"
}, {
    loc: [124.2773, 42.7423],
    fullName: "铁岭市"
}, {
    loc: [123.1238, 42.1216],
    fullName: "沈阳市"
}, {
    loc: [124.585, 41.8579],
    fullName: "抚顺市"
}, {
    loc: [120.1575, 40.578],
    fullName: "葫芦岛市"
}, {
    loc: [122.0032, 42.2699],
    fullName: "阜新市"
}, {
    loc: [121.6626, 41.4294],
    fullName: "锦州市"
}, {
    loc: [123.0798, 40.6055],
    fullName: "鞍山市"
}, {
    loc: [124.1455, 41.1987],
    fullName: "本溪市"
}, {
    loc: [122.4316, 40.4297],
    fullName: "营口市"
}, {
    loc: [123.4094, 41.1383],
    fullName: "辽阳市"
}, {
    loc: [121.9482, 41.0449],
    fullName: "盘锦市"
}, {
    loc: [112.4561, 38.8971],
    fullName: "忻州市"
}, {
    loc: [111.3574, 37.7325],
    fullName: "吕梁市"
}, {
    loc: [111.4783, 36.1615],
    fullName: "临汾市"
}, {
    loc: [112.7747, 37.37],
    fullName: "晋中市"
}, {
    loc: [111.1487, 35.2002],
    fullName: "运城市"
}, {
    loc: [113.7854, 39.8035],
    fullName: "大同市"
}, {
    loc: [112.8625, 36.4746],
    fullName: "长治市"
}, {
    loc: [113.0713, 39.6991],
    fullName: "朔州市"
}, {
    loc: [112.7856, 35.6342],
    fullName: "晋城市"
}, {
    loc: [112.3352, 37.9413],
    fullName: "太原市"
}, {
    loc: [113.4778, 38.0951],
    fullName: "阳泉市"
}, {
    loc: [116.3123, 31.8329],
    fullName: "六安市"
}, {
    loc: [116.7517, 30.5255],
    fullName: "安庆市"
}, {
    loc: [118.1909, 32.536],
    fullName: "滁州市"
}, {
    loc: [118.8062, 30.6244],
    fullName: "宣城市"
}, {
    loc: [115.7629, 32.9919],
    fullName: "阜阳市"
}, {
    loc: [117.5208, 33.6841],
    fullName: "宿州市"
}, {
    loc: [118.0481, 29.9542],
    fullName: "黄山市"
}, {
    loc: [117.7734, 31.4978],
    fullName: "巢湖市"
}, {
    loc: [116.1914, 33.4698],
    fullName: "亳州市"
}, {
    loc: [117.3889, 30.2014],
    fullName: "池州市"
}, {
    loc: [117.29, 32.0581],
    fullName: "合肥市"
}, {
    loc: [117.4109, 33.1073],
    fullName: "蚌埠市"
}, {
    loc: [118.3557, 31.0858],
    fullName: "芜湖市"
}, {
    loc: [116.6968, 33.6896],
    fullName: "淮北市"
}, {
    loc: [116.7847, 32.7722],
    fullName: "淮南市"
}, {
    loc: [118.6304, 31.5363],
    fullName: "马鞍山市"
}, {
    loc: [117.9382, 30.9375],
    fullName: "铜陵市"
}, {
    loc: [118.136, 27.2845],
    fullName: "南平市"
}, {
    loc: [117.5317, 26.3013],
    fullName: "三明市"
}, {
    loc: [116.8066, 25.2026],
    fullName: "龙岩市"
}, {
    loc: [119.6521, 26.9824],
    fullName: "宁德市"
}, {
    loc: [119.4543, 25.9222],
    fullName: "福州市"
}, {
    loc: [117.5757, 24.3732],
    fullName: "漳州市"
}, {
    loc: [118.3228, 25.1147],
    fullName: "泉州市"
}, {
    loc: [119.0918, 25.3455],
    fullName: "莆田市"
}, {
    loc: [118.1689, 24.6478],
    fullName: "厦门市"
}, {
    loc: [119.5642, 28.1854],
    fullName: "丽水市"
}, {
    loc: [119.5313, 29.8773],
    fullName: "杭州市"
}, {
    loc: [120.498, 27.8119],
    fullName: "温州市"
}, {
    loc: [121.5967, 29.6466],
    fullName: "宁波市"
}, {
    loc: [122.2559, 30.2234],
    fullName: "舟山市"
}, {
    loc: [121.1353, 28.6688],
    fullName: "台州市"
}, {
    loc: [120.0037, 29.1028],
    fullName: "金华市"
}, {
    loc: [118.6853, 28.8666],
    fullName: "衢州市"
}, {
    loc: [120.564, 29.7565],
    fullName: "绍兴市"
}, {
    loc: [120.9155, 30.6354],
    fullName: "嘉兴市"
}, {
    loc: [119.8608, 30.7782],
    fullName: "湖州市"
}, {
    loc: [120.2234, 33.5577],
    fullName: "盐城市"
}, {
    loc: [117.5208, 34.3268],
    fullName: "徐州市"
}, {
    loc: [121.1023, 32.1625],
    fullName: "南通市"
}, {
    loc: [118.927, 33.4039],
    fullName: "淮安市"
}, {
    loc: [120.6519, 31.3989],
    fullName: "苏州市"
}, {
    loc: [118.5535, 33.7775],
    fullName: "宿迁市"
}, {
    loc: [119.1248, 34.552],
    fullName: "连云港市"
}, {
    loc: [119.4653, 32.8162],
    fullName: "扬州市"
}, {
    loc: [118.8062, 31.9208],
    fullName: "南京市"
}, {
    loc: [120.0586, 32.5525],
    fullName: "泰州市"
}, {
    loc: [120.3442, 31.5527],
    fullName: "无锡市"
}, {
    loc: [119.4543, 31.5582],
    fullName: "常州市"
}, {
    loc: [119.4763, 31.9702],
    fullName: "镇江市"
}, {
    loc: [106.853, 37.3755],
    fullName: "吴忠市"
}, {
    loc: [105.4028, 36.9525],
    fullName: "中卫市"
}, {
    loc: [106.1389, 35.9363],
    fullName: "固原市"
}, {
    loc: [106.3586, 38.1775],
    fullName: "银川市"
}, {
    loc: [106.4795, 39.0015],
    fullName: "石嘴山市"
}, {
    loc: [109.3291, 19.5653],
    fullName: "儋州市"
}, {
    loc: [110.8905, 19.7823],
    fullName: "文昌市"
}, {
    loc: [109.0283, 18.6301],
    fullName: "乐东黎族自治县"
}, {
    loc: [109.3716, 18.3698],
    fullName: "三亚市"
}, {
    loc: [109.8413, 19.0736],
    fullName: "琼中黎族苗族自治县"
}, {
    loc: [108.8498, 19.0414],
    fullName: "东方市"
}, {
    loc: [110.3893, 19.8516],
    fullName: "海口市"
}, {
    loc: [110.3137, 18.8388],
    fullName: "万宁市"
}, {
    loc: [109.9937, 19.7314],
    fullName: "澄迈县"
}, {
    loc: [109.3703, 19.211],
    fullName: "白沙黎族自治县"
}, {
    loc: [110.4208, 19.224],
    fullName: "琼海市"
}, {
    loc: [109.0407, 19.2137],
    fullName: "昌江黎族自治县"
}, {
    loc: [109.6957, 19.8063],
    fullName: "临高县"
}, {
    loc: [109.9924, 18.5415],
    fullName: "陵水黎族自治县"
}, {
    loc: [110.0377, 19.362],
    fullName: "屯昌县"
}, {
    loc: [110.3384, 19.4698],
    fullName: "定安县"
}, {
    loc: [109.6284, 18.6108],
    fullName: "保亭黎族苗族自治县"
}, {
    loc: [109.5282, 18.8299],
    fullName: "五指山市"
}]
